import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const Svg4VSideViewTableDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M44 28.159 23.412 9 2.824 28.159l10.967 8.165h19.242zm-6.154-1.629H8.977l14.435-13.432zm-23.061 6.793L9.691 29.53h27.442l-5.094 3.793z" })
});
export default Svg4VSideViewTableDown;
